export const LOGIN_SUCCESS = 'cboard/Login/LOGIN_SUCCESS';
export const LOGOUT = 'cboard/Login/LOGOUT';
